// This function works with Waffles to cut out portions of the left and right shadowed scrollbars so that certain underlying
// clickable elements (buttons, links, inputs) are still clickable.
export const getClipPath = (element: HTMLElement): string => {
  if (!element) return 'none';

  const clickableElements = [
    ...document.querySelectorAll('.waffles-row button'),
    ...document.querySelectorAll('.waffles-row a'),
    ...document.querySelectorAll('.waffles-row input'),
    ...document.querySelectorAll('.waffles-row i.fa-plus'),
    ...document.querySelectorAll('.waffles-row i.fa-minus')
  ];

  if (clickableElements.length === 0) return 'none';

  const scrollBarRectangle = element.getBoundingClientRect();
  // Outline the full scroll bar rectangle
  let clipPath = `polygon(
0px 0px,
0px ${scrollBarRectangle.height}px,
${scrollBarRectangle.width}px ${scrollBarRectangle.height}px,
${scrollBarRectangle.width}px 0px,
0px 0px,`;

  // Keep track of the top left corner of the first cutout so we can close the polygon at the end
  const firstCutoutTopLeft: { left: number, top: number } = { left: 0, top: 0 }

  // Cut out rectangles for any underlying clickable elements
  for (const clickableElement of clickableElements) {
    const buttonRectangle = clickableElement.getBoundingClientRect();
    if (
      buttonRectangle.right > scrollBarRectangle.left &&
      buttonRectangle.left < scrollBarRectangle.right &&
      buttonRectangle.bottom > scrollBarRectangle.top &&
      buttonRectangle.top < scrollBarRectangle.bottom
    ) {
      const { width, height } = buttonRectangle;
      const top = buttonRectangle.top - scrollBarRectangle.top;
      const left = buttonRectangle.left - scrollBarRectangle.left;
      // Save the top left corner of the first cutout
      if (firstCutoutTopLeft.top === 0 && firstCutoutTopLeft.left === 0) {
        firstCutoutTopLeft.top = top;
        firstCutoutTopLeft.left = left;
      }
      clipPath += `
${left}px ${top}px,
${Math.min(left + width, scrollBarRectangle.width - 1)}px ${top}px,
${Math.min(left + width, scrollBarRectangle.width - 1)}px ${top + height}px,
${left}px ${top + height}px,
${left}px ${top}px,`;
    }
  }

  // Close the polygon by connecting back to the top left corner of the first cutout
  clipPath += `
${firstCutoutTopLeft.left}px ${firstCutoutTopLeft.top}px)`;

  return clipPath;
}